module.exports = __webpack_public_path__ + "static/media/bg7.8726fd84.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/minibg/bg7.jpg
// module id = 589
// module chunks = 0